import { c as _c } from "react/compiler-runtime";
import { StoreImageEnum, defaultDesignValues, useDesignContext } from '@systemeio/digital-store-shared';
import { LanguageCodeEnum } from '@systemeio/ui';
import { useCourse as useCoursePrecache } from 'modules/courses/courses/hooks/use-course';
import { defaultDigitalProductErrors } from 'modules/digital-product/constants/default-values';
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum';
import { useDigitalProduct } from 'modules/digital-product/hooks/use-digital-product';
import { DigitalProductChangeInterface, DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import ItemActions from 'modules/stores/store/components/item-actions';
import ItemTabs, { ItemTabType } from 'modules/stores/store/components/item-tabs';
import ThankYouTab from 'modules/stores/store/components/tabs/thank-you-tab';
import { STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name';
import Thumbnail from 'modules/stores/store/content/product/components/thumbnail';
import Checkout from 'modules/stores/store/content/product/digital-product/components/checkout';
import { ProductDownloadTabEnum } from 'modules/stores/store/content/product/digital-product/product-download/enum/product-download-tab-enum';
import { defaultErrors } from 'modules/stores/store/content/product/digital-product/product-e-course/constants/default-errors';
import { defaultValues } from 'modules/stores/store/content/product/digital-product/product-e-course/constants/default-values';
import { ECourseTabEnum, tabLocoKeys } from 'modules/stores/store/content/product/digital-product/product-e-course/enum/e-course-tab-enum';
import { useErrorMessageInTabs } from 'modules/stores/store/content/product/digital-product/product-e-course/hooks/use-error-message-in-tabs';
import { getNextTab } from 'modules/stores/store/content/product/digital-product/product-e-course/utils/get-next-tab-e-course';
import { ProductECourseItemEditType, ProductECourseItemErrorsType, ProductECourseItemViewType } from 'modules/stores/store/content/product/types/product-interface';
import { useStoreEditItemContext } from 'modules/stores/store/context/store-item-edit-context';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreContactFields } from 'modules/stores/store/hooks/use-store-contact-fields';
import { StoreId } from 'modules/stores/types/stores-interface';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { ConfirmationModalBeforeExit } from 'shared/confirmation-modal-before-exit/component';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { deepCompare } from 'shared/utils/deepCompare';
import { twMerge } from 'tailwind-merge';
import { useSaveItemProduct } from '../hooks/use-save-item-product';
import Options from './components/options';
import { CourseGateway } from './course-gateway';
import { digitalProductInitFields } from '../constants/mandatory-fields';
interface ECourseEditProps {
  storeId: StoreId;
  item?: ProductECourseItemViewType;
  languageCode: LanguageCodeEnum;
}
const Edit: FC<ECourseEditProps> = t0 => {
  const $ = _c(165);
  const {
    storeId,
    item,
    languageCode
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: storeView
  } = useStore(storeId);
  const [tab, setTab] = useState(ECourseTabEnum.thumbnail);
  const [showSavingButtons, setShowSavingButtons] = useState(true);
  const {
    setState
  } = useDesignContext();
  let t1;
  if ($[0] !== languageCode || $[1] !== t) {
    t1 = t("dashboard.store.product.e_course.title_default", {
      lng: languageCode
    });
    $[0] = languageCode;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== languageCode || $[4] !== t) {
    t2 = t("dashboard.store.product.e_course.subtitle_default", {
      lng: languageCode
    });
    $[3] = languageCode;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== languageCode || $[7] !== t) {
    t3 = t("dashboard.store.product.e_course.button_default", {
      lng: languageCode
    });
    $[6] = languageCode;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== languageCode || $[10] !== t) {
    t4 = t("dashboard.store.product.e_course.checkout.title_default", {
      lng: languageCode
    });
    $[9] = languageCode;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== languageCode || $[13] !== t) {
    t5 = t("dashboard.store.product.e_course.checkout.subtitle_default_tip-tap", {
      lng: languageCode
    });
    $[12] = languageCode;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== languageCode || $[16] !== t) {
    t6 = t("dashboard.store.product.e_course.checkout.button_default", {
      lng: languageCode
    });
    $[15] = languageCode;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      ...defaultValues.checkoutPage,
      title: t4,
      description: t5,
      buttonTitle: t6
    };
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== languageCode || $[23] !== t) {
    t8 = t("dashboard.store.product.download.thank_you.title_default", {
      lng: languageCode
    });
    $[22] = languageCode;
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== languageCode || $[26] !== t) {
    t9 = t("dashboard.store.product.download.thank_you.subtitle_default", {
      lng: languageCode
    });
    $[25] = languageCode;
    $[26] = t;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t8 || $[29] !== t9) {
    t10 = {
      title: t8,
      text: t9
    };
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t1 || $[32] !== t10 || $[33] !== t2 || $[34] !== t3 || $[35] !== t7) {
    t11 = {
      ...defaultValues,
      draft: false,
      title: t1,
      subTitle: t2,
      buttonTitle: t3,
      checkoutPage: t7,
      thankYouPage: t10
    };
    $[31] = t1;
    $[32] = t10;
    $[33] = t2;
    $[34] = t3;
    $[35] = t7;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const defaultValuesWithLoco = t11;
  let t12;
  if ($[37] !== languageCode || $[38] !== t) {
    t12 = t("dashboard.store.product.download.title_default", {
      lng: languageCode
    });
    $[37] = languageCode;
    $[38] = t;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  let t14;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [];
    t14 = [];
    $[40] = t13;
    $[41] = t14;
  } else {
    t13 = $[40];
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t12) {
    t15 = {
      name: t12,
      resources: t13,
      pricePlans: t14,
      confirmationEmail: null
    };
    $[42] = t12;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  const defaultProductValuesWithLoco = t15;
  const [tempState, setTempState] = useState(item || defaultValuesWithLoco);
  const [isDataSaved, setIsDataSaved] = useState(true);
  const {
    data: digitalProduct
  } = useDigitalProduct(tempState.checkoutPage.digitalProductId);
  const [tempProduct, setTempProduct] = useState(digitalProduct ?? defaultProductValuesWithLoco);
  const resource = tempProduct.resources[0];
  const courseId = resource && resource.type === DigitalResourcesTypeEnum.membership_course && resource.course || undefined;
  useCoursePrecache(courseId);
  let t16;
  let t17;
  if ($[44] !== digitalProduct) {
    t16 = () => {
      if (digitalProduct) {
        setTempProduct(digitalProduct);
      }
    };
    t17 = [digitalProduct];
    $[44] = digitalProduct;
    $[45] = t16;
    $[46] = t17;
  } else {
    t16 = $[45];
    t17 = $[46];
  }
  useEffect(t16, t17);
  const {
    errors: initialErrors,
    setErrors: setEditItemErrors
  } = useStoreEditItemContext();
  let t18;
  if ($[47] !== initialErrors) {
    t18 = {
      ...defaultErrors,
      ...initialErrors
    };
    $[47] = initialErrors;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  const [errors, setErrors] = useState(t18);
  const [productErrors, setProductErrors] = useState(defaultDigitalProductErrors);
  let t19;
  if ($[49] !== setEditItemErrors) {
    t19 = () => () => {
      setEditItemErrors({});
    };
    $[49] = setEditItemErrors;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [];
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  useEffect(t19, t20);
  let t21;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = fields => setTempState(prev => ({
      ...prev,
      checkoutPage: {
        ...prev.checkoutPage,
        fields
      }
    }));
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== tempState.checkoutPage.fields) {
    t22 = {
      savedFields: tempState.checkoutPage.fields,
      initFields: digitalProductInitFields,
      onChange: t21
    };
    $[53] = tempState.checkoutPage.fields;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  useStoreContactFields(t22);
  let t23;
  if ($[55] !== storeId || $[56] !== tempProduct || $[57] !== tempState) {
    t23 = {
      tempState,
      tempProduct,
      setTempProduct: setTempProduct as Dispatch<SetStateAction<DigitalProductChangeInterface>>,
      setTempState,
      storeId,
      setErrors,
      setProductErrors,
      defaultErrors
    };
    $[55] = storeId;
    $[56] = tempProduct;
    $[57] = tempState;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  const {
    onPublish,
    isFetchingPublish,
    isFetchingDraft,
    onSaveDraft
  } = useSaveItemProduct(t23);
  let t24;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = [ECourseTabEnum.thank_you, ECourseTabEnum.options];
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  const isPublishAllowed = t24.includes(tab);
  const isCreatingProcess = !item;
  const {
    getTabsWithErrors
  } = useErrorMessageInTabs();
  let t25;
  if ($[60] !== errors || $[61] !== getTabsWithErrors || $[62] !== productErrors) {
    t25 = getTabsWithErrors({
      errors,
      digitalProductErrors: productErrors
    });
    $[60] = errors;
    $[61] = getTabsWithErrors;
    $[62] = productErrors;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  const errorsByTab = t25;
  const isNew = !item;
  const inReadyToSave = isNew ? true : !!digitalProduct;
  let t26;
  if ($[64] !== t) {
    t26 = t(tabLocoKeys[ECourseTabEnum.thumbnail]);
    $[64] = t;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  const t27 = errorsByTab[ECourseTabEnum.thumbnail];
  let t28;
  if ($[66] !== t26 || $[67] !== t27) {
    t28 = {
      key: ECourseTabEnum.thumbnail,
      caption: t26,
      hasError: t27
    };
    $[66] = t26;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== t) {
    t29 = t(tabLocoKeys[ECourseTabEnum.course]);
    $[69] = t;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  const t30 = errorsByTab[ECourseTabEnum.course];
  let t31;
  if ($[71] !== t29 || $[72] !== t30) {
    t31 = {
      key: ECourseTabEnum.course,
      caption: t29,
      hasError: t30
    };
    $[71] = t29;
    $[72] = t30;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t) {
    t32 = t(tabLocoKeys[ECourseTabEnum.checkout]);
    $[74] = t;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  const t33 = errorsByTab[ECourseTabEnum.checkout];
  let t34;
  if ($[76] !== t32 || $[77] !== t33) {
    t34 = {
      key: ECourseTabEnum.checkout,
      caption: t32,
      hasError: t33
    };
    $[76] = t32;
    $[77] = t33;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t) {
    t35 = t(tabLocoKeys[ProductDownloadTabEnum.thank_you]);
    $[79] = t;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  const t36 = errorsByTab[ProductDownloadTabEnum.thank_you];
  let t37;
  if ($[81] !== t35 || $[82] !== t36) {
    t37 = {
      key: ECourseTabEnum.thank_you,
      caption: t35,
      hasError: t36
    };
    $[81] = t35;
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== t) {
    t38 = t(tabLocoKeys[ECourseTabEnum.options]);
    $[84] = t;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  const t39 = errorsByTab[ECourseTabEnum.options];
  let t40;
  if ($[86] !== t38 || $[87] !== t39) {
    t40 = {
      key: ECourseTabEnum.options,
      caption: t38,
      hasError: t39
    };
    $[86] = t38;
    $[87] = t39;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] !== t28 || $[90] !== t31 || $[91] !== t34 || $[92] !== t37 || $[93] !== t40) {
    t41 = [t28, t31, t34, t37, t40];
    $[89] = t28;
    $[90] = t31;
    $[91] = t34;
    $[92] = t37;
    $[93] = t40;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  const tabs = t41;
  let t42;
  if ($[95] !== defaultProductValuesWithLoco || $[96] !== defaultValuesWithLoco || $[97] !== digitalProduct || $[98] !== item || $[99] !== tempProduct || $[100] !== tempState) {
    t42 = () => {
      if (item || digitalProduct) {
        setIsDataSaved(deepCompare({
          item: tempState,
          digitalProduct: tempProduct
        }, {
          item: item ?? defaultValuesWithLoco,
          digitalProduct: digitalProduct ?? defaultProductValuesWithLoco
        }));
      } else {
        setIsDataSaved(deepCompare({
          item: tempState,
          digitalProduct: tempProduct
        }, {
          item: {
            ...defaultValuesWithLoco,
            checkoutPage: {
              ...defaultValuesWithLoco.checkoutPage,
              fields: tempState.checkoutPage.fields,
              description: tempState.checkoutPage.description
            },
            style: tempState.style
          },
          digitalProduct: defaultProductValuesWithLoco
        }));
      }
    };
    $[95] = defaultProductValuesWithLoco;
    $[96] = defaultValuesWithLoco;
    $[97] = digitalProduct;
    $[98] = item;
    $[99] = tempProduct;
    $[100] = tempState;
    $[101] = t42;
  } else {
    t42 = $[101];
  }
  let t43;
  if ($[102] !== tempProduct || $[103] !== tempState) {
    t43 = [tempState, tempProduct];
    $[102] = tempProduct;
    $[103] = tempState;
    $[104] = t43;
  } else {
    t43 = $[104];
  }
  useEffect(t42, t43);
  let t44;
  if ($[105] !== setState || $[106] !== storeView?.design || $[107] !== tab) {
    t44 = () => {
      setShowSavingButtons(tab !== ECourseTabEnum.course || true);
      tab !== ECourseTabEnum.options && tab !== ECourseTabEnum.course && setState(storeView?.design ?? defaultDesignValues.default);
    };
    $[105] = setState;
    $[106] = storeView?.design;
    $[107] = tab;
    $[108] = t44;
  } else {
    t44 = $[108];
  }
  let t45;
  if ($[109] !== tab) {
    t45 = [tab];
    $[109] = tab;
    $[110] = t45;
  } else {
    t45 = $[110];
  }
  useEffect(t44, t45);
  let t46;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col gap-5");
    $[111] = t46;
  } else {
    t46 = $[111];
  }
  let t47;
  if ($[112] !== tab || $[113] !== tabs) {
    t47 = <ItemTabs tabs={tabs} currentTab={tab} setTab={setTab} />;
    $[112] = tab;
    $[113] = tabs;
    $[114] = t47;
  } else {
    t47 = $[114];
  }
  let t48;
  if ($[115] !== errors || $[116] !== tab || $[117] !== tempState) {
    t48 = tab === ECourseTabEnum.thumbnail && <Thumbnail imageType={StoreImageEnum.e_course_thumbnail} tempState={tempState} setTempState={setTempState} errors={errors} />;
    $[115] = errors;
    $[116] = tab;
    $[117] = tempState;
    $[118] = t48;
  } else {
    t48 = $[118];
  }
  let t49;
  if ($[119] !== errors || $[120] !== productErrors || $[121] !== storeView?.currency || $[122] !== storeView?.paymentMethods || $[123] !== tab || $[124] !== tempProduct || $[125] !== tempState) {
    t49 = tab === ECourseTabEnum.checkout && <Checkout tempState={tempState} setTempState={setTempState} tempProduct={tempProduct} setTempProduct={setTempProduct as Dispatch<SetStateAction<DigitalProductChangeInterface>>} errors={errors} pricePlanErrors={productErrors.pricePlans} currency={storeView?.currency} paymentMethods={storeView?.paymentMethods} imageType={StoreImageEnum.e_course_cover} />;
    $[119] = errors;
    $[120] = productErrors;
    $[121] = storeView?.currency;
    $[122] = storeView?.paymentMethods;
    $[123] = tab;
    $[124] = tempProduct;
    $[125] = tempState;
    $[126] = t49;
  } else {
    t49 = $[126];
  }
  let t50;
  if ($[127] !== errors || $[128] !== setState || $[129] !== tab || $[130] !== tempProduct || $[131] !== tempState) {
    t50 = tab === ECourseTabEnum.course && <CourseGateway courseId={tempState.courseId ?? undefined} tempProduct={tempProduct} setTempProduct={setTempProduct as Dispatch<SetStateAction<DigitalProductChangeInterface>>} tempState={tempState} setTempState={setTempState} errors={errors} onToggleLectureEditor={lectureId => {
      setShowSavingButtons(tab !== ECourseTabEnum.course || !lectureId);
      !!lectureId && setState(defaultDesignValues.default);
    }} />;
    $[127] = errors;
    $[128] = setState;
    $[129] = tab;
    $[130] = tempProduct;
    $[131] = tempState;
    $[132] = t50;
  } else {
    t50 = $[132];
  }
  let t51;
  if ($[133] !== productErrors || $[134] !== tab || $[135] !== tempProduct.confirmationEmail || $[136] !== tempState.courseId) {
    t51 = tab === ECourseTabEnum.options && <Options courseId={tempState.courseId ?? undefined} confirmationEmail={tempProduct.confirmationEmail} onChange={confirmationEmail => setTempProduct(prev_0 => ({
      ...prev_0,
      confirmationEmail
    }))} errors={productErrors.confirmationEmail} />;
    $[133] = productErrors;
    $[134] = tab;
    $[135] = tempProduct.confirmationEmail;
    $[136] = tempState.courseId;
    $[137] = t51;
  } else {
    t51 = $[137];
  }
  let t52;
  if ($[138] !== errors || $[139] !== tab || $[140] !== tempState.thankYouPage) {
    t52 = tab === ECourseTabEnum.thank_you && <ThankYouTab thankYouPage={tempState.thankYouPage} onChange={thankYouPage => setTempState(prev_1 => ({
      ...prev_1,
      thankYouPage
    }))} errors={errors} />;
    $[138] = errors;
    $[139] = tab;
    $[140] = tempState.thankYouPage;
    $[141] = t52;
  } else {
    t52 = $[141];
  }
  let t53;
  if ($[142] !== inReadyToSave || $[143] !== isCreatingProcess || $[144] !== isFetchingDraft || $[145] !== isFetchingPublish || $[146] !== isPublishAllowed || $[147] !== onPublish || $[148] !== onSaveDraft || $[149] !== showSavingButtons) {
    t53 = showSavingButtons && <ItemActions publish={{
      disabled: !inReadyToSave,
      onClick: isPublishAllowed || !isCreatingProcess ? onPublish : undefined,
      isFetching: isFetchingPublish
    }} saveDraft={{
      disabled: !inReadyToSave,
      onClick: onSaveDraft,
      isFetching: isFetchingDraft
    }} next={{
      onClick: isCreatingProcess && !isPublishAllowed ? () => setTab(getNextTab) : undefined
    }} />;
    $[142] = inReadyToSave;
    $[143] = isCreatingProcess;
    $[144] = isFetchingDraft;
    $[145] = isFetchingPublish;
    $[146] = isPublishAllowed;
    $[147] = onPublish;
    $[148] = onSaveDraft;
    $[149] = showSavingButtons;
    $[150] = t53;
  } else {
    t53 = $[150];
  }
  let t54;
  if ($[151] !== t) {
    t54 = t("dashboard.store.confirmation_message_before_exit");
    $[151] = t;
    $[152] = t54;
  } else {
    t54 = $[152];
  }
  const t55 = isDataSaved || isFetchingPublish || isFetchingDraft;
  let t56;
  if ($[153] !== t54 || $[154] !== t55) {
    t56 = <ConfirmationModalBeforeExit confirmationText={t54} hideModal={t55} />;
    $[153] = t54;
    $[154] = t55;
    $[155] = t56;
  } else {
    t56 = $[155];
  }
  let t57;
  if ($[156] !== t47 || $[157] !== t48 || $[158] !== t49 || $[159] !== t50 || $[160] !== t51 || $[161] !== t52 || $[162] !== t53 || $[163] !== t56) {
    t57 = <div className={t46}>{t47}{t48}{t49}{t50}{t51}{t52}{t53}{t56}</div>;
    $[156] = t47;
    $[157] = t48;
    $[158] = t49;
    $[159] = t50;
    $[160] = t51;
    $[161] = t52;
    $[162] = t53;
    $[163] = t56;
    $[164] = t57;
  } else {
    t57 = $[164];
  }
  return t57;
};
export default Edit;